import {
  AddressEstablishment,
  Areas,
  EstablishmentType,
  NameOption,
  NatureLocal,
  SocialObject,
  Society,
} from '../../../../../../types';

function hasText(value?: string | string[]) {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.join(' ').trim().length > 0;
  }

  return false;
}

function hasPositiveNumber(value?: number) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

export interface DataCollectValidationInput {
  socialObject: SocialObject;
  names: NameOption;
  address: AddressEstablishment;
  areaT: Areas;
  establishment: EstablishmentType;
  society: Society;
  localNature: NatureLocal | number;
  iptu?: { iptu?: string };
}

export function getDataCollectValidationErrors({
  socialObject,
  names,
  address,
  areaT,
  establishment,
  society,
  localNature,
  iptu,
}: DataCollectValidationInput) {
  const localNatureCode = getLocalNatureCode(localNature);
  const iptuIsRequired = isIptuRequired(localNature);
  const errors: string[] = [];

  if (typeof localNatureCode !== 'number') errors.push('localNature');
  if (!hasText(socialObject?.body)) errors.push('socialObject.body');
  if (!hasText(names?.name1)) errors.push('names.name1');
  if (!hasText(names?.name2)) errors.push('names.name2');
  if (!hasText(names?.name3)) errors.push('names.name3');
  if (!hasText(address?.city)) errors.push('address.city');
  if (!hasText(address?.uf)) errors.push('address.uf');
  if (!hasText(address?.neighborhood)) errors.push('address.neighborhood');
  if (!hasText(address?.log)) errors.push('address.log');
  if (!hasText(address?.logType)) errors.push('address.logType');
  if (!hasPositiveNumber(address?.numLog)) errors.push('address.numLog');
  if (!hasPositiveNumber(areaT?.totalArea)) errors.push('areaT.totalArea');
  if (!hasPositiveNumber(areaT?.utilArea)) errors.push('areaT.utilArea');
  if (!hasText(establishment?.type)) errors.push('establishment.type');
  if (!Array.isArray(establishment?.option) || establishment.option.length === 0) {
    errors.push('establishment.option');
  }
  if (!hasText(society?.cpf)) errors.push('society.cpf');
  if (!hasText(society?.name)) errors.push('society.name');
  if (!hasPositiveNumber(society?.house_number)) errors.push('society.house_number');
  if (iptuIsRequired && !hasText(iptu?.iptu)) errors.push('iptu.iptu');

  return errors;
}

export function getLocalNatureCode(localNature: NatureLocal | number) {
  if (typeof localNature === 'number') {
    return localNature;
  }

  if (
    typeof localNature === 'object' &&
    localNature !== null &&
    typeof localNature.local === 'number'
  ) {
    return localNature.local;
  }

  return undefined;
}

export function isIptuRequired(localNature: NatureLocal | number) {
  const localNatureCode = getLocalNatureCode(localNature);
  return localNatureCode === 0 || localNatureCode === 1;
}

export function isDataCollectValid({
  socialObject,
  names,
  address,
  areaT,
  establishment,
  society,
  localNature,
  iptu,
}: DataCollectValidationInput) {
  return getDataCollectValidationErrors({
    socialObject,
    names,
    address,
    areaT,
    establishment,
    society,
    localNature,
    iptu,
  }).length === 0;
}
